import { defineStore } from 'pinia';
import { getCurrentUserProfile } from '@/api/rbac/user';

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: null,
    token: localStorage.getItem('token') || '',
  }),
  
  getters: {
    isLoggedIn: (state) => !!state.token,
    username: (state) => state.userInfo?.username || '',

    id: (state) => state.userInfo?.id || '',
    
    // 获取用户角色列表
    userRoles: (state) => state.userInfo?.roles || [],
    
    // 判断是否为管理员角色
    isAdmin: (state) => {
      const roles = state.userInfo?.roles || [];
      return roles.some(role => role.code === 'admin');
    },
    
    // 获取用户权限列表
    userPermissions: (state) => state.userInfo?.permissions || [],
  },
  
  actions: {
    // 登录
    setToken(token) {
      this.token = token;
      localStorage.setItem('token', token);
    },

    async fetchUserInfo() {
      if (!this.token) return;
      
      const res = await getCurrentUserProfile();
      console.log('User info:', res.data);
      this.userInfo = res.data;
    },
    
    // 设置用户信息
    setUserInfo(info) {
      this.userInfo = info;
    },
    
    // 登出
    logout() {
      this.token = '';
      this.userInfo = null;
      localStorage.removeItem('token');
      // 清除菜单缓存，确保切换账号后重新加载菜单
      localStorage.removeItem('userMenus');
      // 清除菜单展开状态
      localStorage.removeItem('menuOpenKeys');
    },
    
    // 检查是否有指定权限
    hasPermission(permissionCode) {
      // admin 角色拥有所有权限
      if (this.isAdmin) {
        return true;
      }
      // 检查用户是否有该权限
      return this.userPermissions.some(p => p.code === permissionCode);
    },
    
    // 检查是否有指定角色
    hasRole(roleCode) {
      return this.userRoles.some(r => r.code === roleCode);
    },
    
    // 检查是否有任一权限
    hasAnyPermission(permissionCodes) {
      // admin 角色拥有所有权限
      if (this.isAdmin) {
        return true;
      }
      // 检查用户是否有任一权限
      return permissionCodes.some(code => this.hasPermission(code));
    },
    
    // 检查是否有所有权限
    hasAllPermissions(permissionCodes) {
      // admin 角色拥有所有权限
      if (this.isAdmin) {
        return true;
      }
      // 检查用户是否有所有权限
      return permissionCodes.every(code => this.hasPermission(code));
    },
  },
});
